import { render, staticRenderFns } from "./DeliveryRelated_Row_Total.vue?vue&type=template&id=215974c2&"
import script from "./DeliveryRelated_Row_Total.vue?vue&type=script&lang=js&"
export * from "./DeliveryRelated_Row_Total.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports